import React from "react";
import moment from "moment-timezone";
import { getFormattedDateTime } from "../../../helpers/helpers";
import { DATE_FORMAT } from "../../../constants";
import _ from "lodash";

const alloweDateFormats = ["DD/MM/YYYY", "DD-MM-YYYY", "DD/MM/YY"];

const getFormattedDate = (value) => {
  const currDateFormat = alloweDateFormats.find((format) =>
    moment(value, format).isValid()
  );
  if (!currDateFormat) return "--";
  return moment(value, currDateFormat).format(DATE_FORMAT);
};

const renderField = (type = "", value) => {
  switch (type.toLowerCase()) {
    case "string":
      return _.isEmpty(value) ? "--" : value;
    case "date":
      return _.isEmpty(value) ? "--" : getFormattedDate(value);
    case "datetime":
      return _.isEmpty(value) ? "--" : getFormattedDateTime(value, true, false);
    case "list":
      return _.isEmpty(value) ? "--" : value.join(", ");
    case "number":
      return _.isEmpty(value) ? "--" : value;
    case "boolean":
      return _.isEmpty(value) ? "--" : value ? "Yes" : "No";
    case "file":
      return (
        <a href={value?.url ?? "#"} target="_blank" rel="noopener noreferrer">
          {value?.name ?? value?.url ?? "--"}
        </a>
      );
    case "url":
      return _.isEmpty(value) ? (
        "--"
      ) : (
        <a href={value ?? "#"} target="_blank" rel="noopener noreferrer">
          {value}
        </a>
      );
    default:
      return value;
  }
};

const AdditionFieldItem = ({ label, type, value }) => {
  const formattedValue = renderField(type, value);
  return (
    <div className="additional-field-item-wrapper">
      <div className="additional-field-label">{label}</div>
      <div className="additional-field-value">{formattedValue}</div>
      {/* <input
        className="additional-field-value form-control"
        value={formattedValue}
        readOnly
      /> */}
      {/* <div className="additional-field-value form-control">
        <span>{formattedValue}</span>
      </div> */}
    </div>
  );
};

export default AdditionFieldItem;
